import { FC, useRef } from "react";

import classes from "./SectionHeader.module.css";
import { useNavigate } from "react-router-dom";
import { getLang, i18n } from "../../i18n";

interface Props {
  label: string;
  loader?: boolean;
  back?: string;
  skip?: string;
  replace?: string;
  cancel?: string;
  black?: boolean;
  preUploadImage?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  skipHandler?: (_id: string) => Promise<void>;
}

const SectionHeader: FC<Props> = ({
  label,
  loader = false,
  back,
  skip,
  replace,
  cancel,
  black = false,
  preUploadImage,
  skipHandler,
}) => {
  const lang = getLang();
  const t = i18n.sectionHeader[lang];

  const navigate = useNavigate();
  const fileRef = useRef<HTMLInputElement>(null);
  return (
    <header
      className={`${classes.sectionHeader} ${black ? classes.black : ""}`}
    >
      {preUploadImage && (
        <input
          ref={fileRef}
          type="file"
          accept=".png,.jpg,.gif,.jpeg,.webp,.avif"
          className={classes.file}
          onChange={(e) => {
            preUploadImage(e);
          }}
        />
      )}
      {back && (
        <a
          onClick={() => {
            navigate(-1);
          }}
          className={classes.back}
        >
          <svg
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.2956 11.9213H8.61849L14.4414 6.09839L12.9622 4.62964L4.62891 12.963L12.9622 21.2963L14.431 19.8276L8.61849 14.0046H21.2956V11.9213Z"
              fill="#000"
            />
          </svg>
        </a>
      )}
      <h1>{label}</h1>
      {skip && skipHandler && (
        <a
          onClick={() => {
            skipHandler(skip);
          }}
          className={classes.skip}
        >
          {t.skip}
        </a>
      )}
      {replace && (
        <a
          onClick={() => {
            fileRef.current?.click();
          }}
          className={classes.skip}
        >
          {t.replace}
        </a>
      )}
      {cancel && (
        <a
          onClick={() => {
            navigate(-1);
          }}
          className={classes.cancel}
        >
          {t.cancel}
        </a>
      )}
      {loader && <div className={classes.loader}></div>}
    </header>
  );
};

export default SectionHeader;
